import React from "react";
import "./QRAttendance.css";
import { 
  CheckCircleFilled, 
  ArrowRightOutlined,
  DatabaseOutlined,
  SafetyCertificateOutlined,
  RocketOutlined,
  QrcodeOutlined,
  CheckOutlined,
  CloudOutlined,
  ThunderboltFilled,
} from "@ant-design/icons";
import attendanceImage from "../../Asset/qr-attendance.png"; 

const featuresLeft = [
  "Touchless QR Scanning",
  "Employee Geo-Fencing (GPS)",
  "Manage Multiple Branches",
  "Real-time Attendance Sync",
  "Dynamic QR Generation",
  "Leave & Holiday Management",
  "Automated Timesheets",
  "Late & Overtime Tracking",
  "Shift Roaster Management",
  "Employee Self-Service",
];

const featuresRight = [
  "Payroll Software Integration",
  "WhatsApp & SMS Alerts",
  "Daily/Monthly Reports",
  "Export Excel & PDF",
  "Biometric Anti-Spoofing",
  "Admin & HR Dashboard",
  "Device Agnostic (Mobile/Tablet)",
  "Customizable HR Policies",
  "Role-based Access Control",
  "Zero Proxy Attendance",
];

const highlights = [
  {
    icon: <DatabaseOutlined />,
    title: "Cloud Database",
    desc: "Secure distributed data system",
  },
  {
    icon: <SafetyCertificateOutlined />,
    title: "Anti-Proxy Security",
    desc: "Geo-lock & dynamic QR",
  },
  {
    icon: <RocketOutlined />,
    title: "Fast Operations",
    desc: "Millisecond scan & sync",
  },
];

const QRAttendance = () => {
  const handleViewMore = () => {
    window.open("/qr-attendance", "_blank");
  };

  return (
    <div className="tms-page-light">
      {/* Decorative Background */}
      <div className="tms-bg-grid"></div>
      <div className="tms-glow-1"></div>
      <div className="tms-glow-2"></div>

      <div className="tms-container">
        
        {/* ═══════ NEW SIMPLE & PROFESSIONAL HEADER ═══════ */}
        <div className="tms-header-new">
          <div className="tms-header-top">
            <span className="tms-badge">
              <span className="tms-badge-dot"></span>
              HR Attendance PRODUCT
            </span>
            <span className="tms-version-tag">
              <ThunderboltFilled /> Version 2.0
            </span>
          </div>

          <div className="tms-header-main">
            <div className="tms-header-icon-box">
              {/* CarOutlined ki jagah QrcodeOutlined use kiya hai */}
              <QrcodeOutlined />
            </div>
            <div className="tms-header-text">
              <h1 className="tms-title-new">
                Smart QR Attendance <span className="tms-gradient-text">System</span>
              </h1>
              <p className="tms-subtitle-new">
                An enterprise-grade digital platform designed to streamline daily employee attendance, 
                automate timesheets, and empower HR teams with real-time workforce insights.
              </p>
            </div>
          </div>

          {/* Meta Info Pills */}
          <div className="tms-meta-pills">
            <span className="tms-meta-pill">
              <CheckOutlined /> Live Demo Available
            </span>
            <span className="tms-meta-pill">
              <SafetyCertificateOutlined /> Enterprise Ready
            </span>
            <span className="tms-meta-pill">
              <CloudOutlined /> Cloud-Based Software
            </span>
            <span className="tms-meta-pill">
              <QrcodeOutlined /> Touchless Solution
            </span>
          </div>
        </div>

        {/* MAIN CONTENT GRID */}
        <div className="tms-main-content">
          
          {/* LEFT — IMAGE & HIGHLIGHTS */}
          <div className="tms-left-col">
            <div className="tms-image-wrapper">
              <div className="tms-image-glow"></div>
              <img
                src={attendanceImage}
                alt="QR Attendance System"
                className="tms-image"
              />
              <div className="tms-image-badge">
                <QrcodeOutlined /> Scanner App
              </div>
            </div>

            {/* Highlights Row */}
            <div className="tms-highlights">
              {highlights.map((item, index) => (
                <div className="tms-highlight-card" key={index}>
                  <div className="tms-highlight-icon">{item.icon}</div>
                  <div className="tms-highlight-text">
                    <h5>{item.title}</h5>
                    <p>{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* RIGHT — INFORMATION */}
          <div className="tms-right-col">
            <div className="tms-info-block">
              <p className="tms-para">
                A system called <strong>Smart QR Attendance</strong> was 
                created to help <strong>Offices, Factories, and Educational Institutes</strong> properly handle 
                their everyday attendance tracking. In other words, this software completely 
                automates the time-tracking process from end-to-end, replacing outdated biometric machines.
              </p>

              <p className="tms-para">
                This system is essentially a <strong>touchless cloud-based platform</strong> that 
                may be accessed using any smartphone or tablet. It empowers HR managers, admins, 
                and business owners to manage daily workforce activities with maximum efficiency, 
                accuracy, and zero proxy attendance.
              </p>
            </div>

            {/* FEATURES SECTION */}
            <div className="tms-features-section">
              <h2 className="tms-features-title">
                <span className="title-accent">Key Features</span> & Benefits
              </h2>
              <p className="tms-features-desc">
                Explore the comprehensive suite of features designed to elevate 
                your HR and Admin management.
              </p>

              <div className="tms-features-grid">
                <ul className="tms-features-list">
                  {featuresLeft.map((feature, index) => (
                    <li key={index}>
                      <CheckCircleFilled className="tms-check-icon" />
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>

                <ul className="tms-features-list">
                  {featuresRight.map((feature, index) => (
                    <li key={index}>
                      <CheckCircleFilled className="tms-check-icon" />
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            {/* CTA BUTTON */}
            {/* <div className="tms-cta-wrap">
              <button className="tms-view-btn" onClick={handleViewMore}>
                <span>Explore Full Details</span>
                <ArrowRightOutlined />
              </button>
              <p className="tms-cta-note">
                💡 Get a live demo and pricing consultation
              </p>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default QRAttendance;